/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { Menu } from "./styles";
import { useState, useEffect } from "react";
import { Nav, NavItem } from 'uikit-react';
import { GetApi, logout, getProfCliente } from "../../services/auth";
import { ListaMenu } from "../../constants";

let visao = localStorage.getItem("Cargo")
let visaoProd = localStorage.getItem("cliente_prof_forn")
let entEmpregador = localStorage.getItem("empregador")

const currentPath = window.location.pathname;
const perfilCodLocal = localStorage.getItem('perfilAcesso');
export function Navigation() {
  const profissao = getProfCliente();
  const [activeItem, setActiveItem] = useState(currentPath);
  const [perfilAdmin, setPerfilAdmin] = useState("");
  // const [AdminMaster, setAdminMaster] = useState(6006);

  useEffect(() => {
    if (currentPath === '/admin/Relatorios') {
      setActiveItem('Relatorios');
    } else {
      setActiveItem('');
    }
  }, []);

  useEffect(() => {
    if(perfilCodLocal === null){
      dadosUser();
    } else {
      setPerfilAdmin(perfilCodLocal);
    }

  }, []);

  const dadosUser = async () => {
    const response = await GetApi("Cliente/ListarClienteDoc/");

    if (response?.data.sucesso) {
      const perfilAdmin = response.data?.codigoExterno ?? ''

      setPerfilAdmin(perfilAdmin);
    }
  };


  return (
    <Menu>
      <div id="sidebar" className="tm-sidebar-left uk-background-white uk-left-menu-inative">

          <Nav accordion preset="default" className="uk-nav-default uk-nav-parent-icon" options="multiple: false; transition: ease; collapsible: true; duration: 700">
            <NavItem>
              <a href="/admin/MenuRapido">
                <span className="uk-icon" uk-icon="icon:  grid"></span>Painel
              </a>
            </NavItem>
            <li className="uk-nav-divider" />

            {ListaMenu.map((item, index) => (
              (item.master && profissao !== "6005") ? null :
              <NavItem key={index}>
                <a href={item.link}>
                  <span className="uk-icon" uk-icon={`icon: ${item.icone}`}></span>
                  {item.menu}
                </a>
              <li className="uk-nav-divider" />
              </NavItem>
            ))}

            <NavItem>
              <a onClick={() => logout()}>
                <span className="uk-icon" uk-icon="icon: logout"></span>
                Sair
              </a>
            </NavItem>

          </Nav>        

        
      </div>
    </Menu>
  );
}
